import axios from "axios";
import { decryptRequest } from "../utils/crypt";

const refreshTokenFetch = async () => {
  const localStorageToken = localStorage.getItem("token");
  const { data } = await axios.post(
    `https://godrej.app-assertai.com:5000/Auth/refreshtoken`,
    {
      refreshToken: localStorageToken,
    }
  );
  let dataafterdecryption = await decryptRequest(data.data);
  console.log("Data After Decryption ----> ", JSON.parse(dataafterdecryption));
  // Update the token in localStorage
  localStorage.setItem("token", JSON.parse(dataafterdecryption).data);
  return { status: data.status, message: data.message };
};

export { refreshTokenFetch };
